<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Fred Geary lived and raised in Tehran, the capital of Persia, by a middle-class cultured family. During the Shah of Persia reign, he went to school and college.</p><br/>
<p style="text-indent:0em;">Although his mother likes him to get into the high school where she was the principal, he hesitated not to take advantage of being under her blanket because of a bad experience from the past staying one year in the junior school under her control.</p><br/>
<p style="text-indent:0em;">After graduation, he insisted on traveling abroad and facing the western countries, which have made him curious all his teens times. He flew first to Germany for a month as the guest of his brother, and then he went to London, where he was supposed to take courses in a master’s degree program. And from there, he experienced different phenomena of life. Two times engaged and marrying with the third woman of his life. Soon after he went to the USA and entered in USF master program (MBA).</p><br/>
<p style="text-indent:0em;">Coming back to Tehran at the beginning of 1980, and marrying for the second time, and experiencing war, revolution, and mismanagement of the fanatic authorities resulted in poverty, pain for the people. And all these together made him think and study Islam and many other religions and forms of government.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?228916e0